export default __webpack_public_path__ + "static/media/LogoItprofes-gray.17b3c239.svg";